import {
  ApdmApproveReplyDraftInput,
  ApdmDraftStatus,
  ApdmReplyDraftReviewDetailResult,
  ApdmReplyDraftReviewSummary,
  ApdmReviewReason,
  ApdmSendState,
  RpaMessageType,
} from '@euler/model/apdm';

export enum ApdmReviewAction {
  Send = 'send',
  EditSend = 'edit-send',
  Discard = 'discard',
}
export function canReviewApdmDraft(
  draft: ApdmReplyDraftReviewSummary,
  now = Date.now(),
): boolean {
  return (
    draft.status === ApdmDraftStatus.Pending &&
    draft.sendState === ApdmSendState.Due &&
    Date.parse(draft.expiresAt) > now
  );
}
export function apdmReviewActionInput(
  detail: ApdmReplyDraftReviewDetailResult,
): ApdmApproveReplyDraftInput {
  return {
    ref: { ...detail.draft.ref },
    expectedFingerprint: detail.draft.fingerprint,
  };
}
export const apdmReviewIntentLabels: Record<ApdmReviewReason, string> = {
  service_status: '客户询问服务状态',
  service_progress: '客户询问服务进度',
  finish_time: '客户询问完成时间',
  findings: '客户询问检测发现',
  construction_info: '客户询问施工信息',
  service_items: '客户询问服务项目',
  greeting: '客户打招呼',
  escalate: '客户需要人工协助',
  opt_out: '客户不希望继续联系',
  out_of_scope: '需要顾问核实',
  follow_up: '客户尚未回复，主动跟进',
  campaign_inquiry: '客户咨询活动',
  campaign_booking: '客户表达预约意向',
  campaign_not_interested: '客户暂时不感兴趣',
};
export const apdmDraftStatusLabels: Record<ApdmDraftStatus, string> = {
  pending: '待审核',
  approved: '已提交，等待发送',
  sent: '已发送',
  discarded: '已丢弃',
  expired: '已过期',
  failed: '发送失败',
};

export const rpaReviewMessageLabels: Record<RpaMessageType, string> = {
  text: '文字消息',
  image: '图片消息',
  video: '视频消息',
  link: '链接消息',
  voice: '语音消息',
  miniprogram: '小程序消息',
  other: '其他消息',
};
